<div
  class="rounded shadow-lg pointer-events-none whitespace-nowrap z-999"
  [ngClass]="{
    'text-[11px] px-2 py-0.5': size() === 'sm',
    'text-xs px-2.5 py-1': size() === 'md',
    'text-sm px-3 py-1.5': size() === 'lg',
    'bg-white text-black dark:text-white dark:bg-black': color() === 'primary',
    'bg-sky-600 text-white': color() === 'info',
    'bg-green-500 text-white': color() === 'success',
    'bg-amber-400 text-black': color() === 'warning',
    'bg-red-700 text-white': color() === 'danger'
  }"
>
  {{ text() }}
</div>
